'use strict';

var templates = require('../templates');
var fobclient = require('..');
var ExterneOrganisation = require('../entity').ExterneOrganisation;

module.exports = function (connection) {
  return {
    byKurznameEquals: function byKurznameEquals(kurzname, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byKurznameEquals', 'kurzname')(kurzname, additionalParams);
    },
    byIdHsLike: function byIdHsLike(idhs, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byIdHsLike', 'idhs')(idhs, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byBeschreibungLike: function byBeschreibungLike(beschreibung, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byBeschreibungLike', 'beschreibung')(beschreibung, additionalParams);
    },
    byHsNrEquals: function byHsNrEquals(hsnr, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byHsNrEquals', 'hsnr')(hsnr, additionalParams);
    },
    byBeschreibungEquals: function byBeschreibungEquals(beschreibung, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byBeschreibungEquals', 'beschreibung')(beschreibung, additionalParams);
    },
    byStadtEquals: function byStadtEquals(stadt, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byStadtEquals', 'stadt')(stadt, additionalParams);
    },
    byHsNrLike: function byHsNrLike(hsnr, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byHsNrLike', 'hsnr')(hsnr, additionalParams);
    },
    byKurznameLike: function byKurznameLike(kurzname, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byKurznameLike', 'kurzname')(kurzname, additionalParams);
    },
    byIdHsEquals: function byIdHsEquals(idhs, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byIdHsEquals', 'idhs')(idhs, additionalParams);
    },
    byLandEquals: function byLandEquals(land, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byLandEquals', 'land')(land, additionalParams);
    },
    byNameEquals: function byNameEquals(name, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byNameEquals', 'name')(name, additionalParams);
    },
    byNameLike: function byNameLike(name, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byNameLike', 'name')(name, additionalParams);
    },
    byStadtLike: function byStadtLike(stadt, additionalParams) {
      return templates.searchTemplate(connection)(ExterneOrganisation, 'byStadtLike', 'stadt')(stadt, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(ExterneOrganisation, 'genericand')(searchParams);
    },
    byMultiValueSearchRep: function byMultiValueSearchRep(searchParams) {
      return templates.genericSearchTemplate(connection)(ExterneOrganisation, 'byMultiValueSearchRep')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('externeorganisation')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/externeOrganisation.js
// module id = 2WFc
// module chunks = 0